import React, { useEffect } from 'react'
import { Route, Redirect, withRouter } from 'react-router-dom'
import { getUser } from '../utilties/userUtilities'
import queryString from 'query-string'
import { useDispatch } from 'react-redux'
import { externalAuth } from '../redux/actions'

export default ({location}) => {
	const dispatch = useDispatch()

	useEffect(
		() => {
			let params = queryString.parse(location.search)
			dispatch(externalAuth(params.data))
		},
		[]
	)

	return null
}
